function initPriceSlider() {
    var parent = document.querySelector(".range-slider");
    if(!parent) return;

    var
        rangeS = parent.querySelectorAll("input[type=range]"),
        numberS = parent.querySelectorAll("input[type=number]");
        rangeS.forEach(function(el) {
        el.oninput = function() {
        var slide1 = parseFloat(rangeS[0].value),
            slide2 = parseFloat(rangeS[1].value);

        if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
        }

        numberS[0].value = slide1;
        numberS[1].value = slide2;
        }
    });

    numberS.forEach(function(el) {
        el.oninput = function() {
        var number1 = parseFloat(numberS[0].value),
        number2 = parseFloat(numberS[1].value);
                
        if (number1 > number2) {
            var tmp = number1;
            numberS[0].value = number2;
            numberS[1].value = tmp;
        }

        rangeS[0].value = number1;
        rangeS[1].value = number2;

        }
    });
}
 
jQuery(document).ready(function ($){    
    $.noConflict();

     

    // Delay Load  
    $('.header-container, .header-container-mobile, .snow-announcements, #header-mobile-drawer, .sa-banner-main, .header-wrapper .header__inline-menu .icon, .basic-sub-navigation-mobile .icon, .mobile-drawer-menu .icon').css({"visibility": "visible", "opacity": "1"});

    // Open new window outgoing URLs, ignoring snow blocks and sso links 
    $('a:not(.snowBlockLink, .quick-view, .csb-link, .same-tab-link, .logout-link, .section--contact-information, .learn-more-edd, .edd-exceptions)').attr('target', function() {
        if(this.host == location.host) return '_self'
        else return '_blank'
    });

    // NSFW Button
     $('#ageTermsCheck').change(function () {
        $('#submit_birthdate').prop("disabled", !this.checked);
    });

    $('#ageTermsCheck').click(function () {
        if ($(this).is(':checked')){
            $("#submit_birthdate").css('opacity', 1);
        } else {
            $("#submit_birthdate").css('opacity', 0.1);
        }
    });

    // Search Auto-Focus
    
        $('.header__icon--search').click(function (){
            $(".search__input").focus();
        });
     

    // Mega Menu
    $('.header__icon--menu').click(function (){
        $('body').toggleClass('locked');
    });

    $(".full-height-close.header__icon--menu").click(function() {
        $(".header__icon.header__icon--menu.mobile").toggleClass("open");
    });
    
    if (!$('.mega-menu-item').hasClass('blank')){
        $(this).find('span svg:not(.slide-panel-inner-container span svg)').css('display', 'inline-block');
    }

    $('.mega-menu-item').hover(function() {
        if (!$(this).hasClass('blank')){
            $(this).addClass('active');
            $('.header-mm-overlay').show();
        }
      }, function() {
        $(this).removeClass('active');
        $('.header-mm-overlay').hide();
    });

    function searchLayout(){
    $('.header__icon--search').click(function(){
        
        $('.search-slideout').slideToggle(function() {
          document.getElementById("Search-In-Modal-1").focus();
        });
      
        $('.search-overlay').fadeIn(500);
    });
    
    $('.search-overlay-close').click(function (){
        $('.search-overlay').fadeOut(500);
    });

    
    }
    searchLayout();
    
    if (Shopify.designMode){
      document.addEventListener('shopify:section:load', function(){
          if(event.detail.sectionId === '') {
              searchLayout();
          }
      });
    }

    // Back to Top Button
    let backToTop2 = $("#backToTop");
    if ($(window).scrollTop() > 300) { 
        backToTop2.removeClass("hidden");
    
    } 
    $(window).on("scroll", () => {
        if ($(window).scrollTop() < 300) {
            backToTop2.fadeOut(500, () => {
                backToTop2.addClass("hidden");
            });
        } else {
            backToTop2.fadeIn(500);
            backToTop2.removeClass("hidden");
        }
    });
    backToTop2.on("click", () => {
        $('html, body').animate({ scrollTop:0 }, '300');
    });

    // Collection Sidebar
    $(".disclosure-has-dropdown .facets__summary").on("click", function(){
        $(this).toggleClass("active");
    }); 

    if($('.collection-sidebar-container .facets-container .facets__wrapper').find('.disclosure-has-dropdown').length == 0) {
		$(".collection-sidebar-container .facets-container").hide();
        $(".collection-sidebar-container #ProductGridContainer .collection.page-width").css({"padding": "0"});
    }

    // Price Range Slider
    initPriceSlider();

    // Window Resize
    let mobileBreakpoint = "970px";
    $(window).resize(function() {
      if ($(window).width() <= mobileBreakpoint) {
        $('.header__icon--menu').removeClass('open');
      }
    });

    

     if ($(".left-mobile-facets").length > 0) {
         $(".left-mobile-facets").on('click', function() {
             $(".mobile-facets__disclosure.disclosure-has-popup.menu-opening").removeClass("menu-opening").removeAttr("open");
             $("summary.mobile-facets__open-wrapper").removeAttr("aria-expanded");
         });
     }

     /* Window Message Handling */
     function windowMessaging() {
     window.addEventListener('message', function(m) {
         if (m.data.type == 'cart_drawer') {
             if (m.data.action == 'open') {
                 if (!$("body").hasClass("locked")) {
                     $("body").addClass("locked");
                 }
               }
             else if (m.data.action == 'close') {
                 if ($("body").hasClass("locked")) {
                     $("body").removeClass("locked");
                 }
             }
         }
         
       });
     };
     windowMessaging();

     if (Shopify.designMode){
         document.addEventListener('shopify:section:load', function(){
             if(event.detail.sectionId === '') {
                 windowMessaging();
             }
         });
     }
});